"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var graphql_request_1 = require("graphql-request");

var framework_1 = require("../../core/framework");

var Repository =
/** @class */
function (_super) {
  __extends(Repository, _super);

  function Repository() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Repository.prototype.getLocationByCoordinates = function (lat, lng) {
    return this.request(graphql_request_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        query GetLocationByCoordinates($input: PlaceDetailsByLocationInput!) {\n          placeDetailsByLocation(input: $input) {\n            placeId\n            address\n          }\n        }\n      "], ["\n        query GetLocationByCoordinates($input: PlaceDetailsByLocationInput!) {\n          placeDetailsByLocation(input: $input) {\n            placeId\n            address\n          }\n        }\n      "]))), {
      input: {
        lat: lat,
        lng: lng
      }
    });
  };

  Repository.prototype.sendOTP = function (phone, marketId) {
    return this.request(graphql_request_1.gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        mutation OtpRequest($input: MarketOtpRequestInput!) {\n          marketOtpRequest(input: $input) {\n            success\n          }\n        }\n      "], ["\n        mutation OtpRequest($input: MarketOtpRequestInput!) {\n          marketOtpRequest(input: $input) {\n            success\n          }\n        }\n      "]))), {
      input: {
        phone: phone,
        marketId: marketId,
        invitationToken: null,
        isRegistration: true
      }
    });
  };

  Repository.prototype.confirmOTP = function (phone, marketId, otp) {
    return this.request(graphql_request_1.gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        mutation OtpLogin($input: MarketOtpLoginInput!) {\n          marketOtpLogin(input: $input) {\n            token\n          }\n        }\n      "], ["\n        mutation OtpLogin($input: MarketOtpLoginInput!) {\n          marketOtpLogin(input: $input) {\n            token\n          }\n        }\n      "]))), {
      input: {
        otp: otp,
        phone: phone,
        marketId: marketId,
        invitationToken: null
      }
    });
  };

  return Repository;
}(framework_1.RepositoryBase);

exports.default = Repository;
var templateObject_1, templateObject_2, templateObject_3;